import { render, staticRenderFns } from "./UpsellScreen.vue?vue&type=template&id=a9f5ae2e"
import script from "./UpsellScreen.vue?vue&type=script&lang=js"
export * from "./UpsellScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports